<template>
  <div class="coding-test">
    <StatusRedirect status="DURING_TEST" @rewrite="checkApplicantStatus" />
    <div v-if="applicantStatus === 'DURING_TEST'">
      <div class="two-button">
        <Timer />
        <b-button
          class="end-button"
          variant="danger"
          @click="callConfiramationDialog"
        >
          試験終了
        </b-button>
      </div>
      <div class="h-iframe">
        <iframe
          id="code-server"
          title="VS Code"
          frameborder="0"
          style="border:0"
          allowfullscreen
          :src="iframePath"
          v-if="isIframeMounted"
        />
      </div>
      <b-overlay :show="isConfiramationDialog" no-wrap>
        <template #overlay>
          <div class="text-center p-3">
            <p><strong id="form-confirm-label">本当に試験を終了しますか?</strong></p>
            <div class="d-flex justify-content-center">
              <b-button variant="outline-secondary" class="mr-3" @click="onCancel">
                キャンセル
              </b-button>
              <b-button variant="outline-danger" @click="callUpdateApplicantStatusAndRedirect">終了</b-button>
            </div>
          </div>
        </template>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import StatusRedirect from '@/main/frontend/components/StatusRedirect.vue';
import Timer from '@/main/frontend/pages/coding_test/Timer.vue';

export default {
  components: {
    StatusRedirect,
    Timer,
  },
  data() {
    return {
      applicantStatus: '',
      iframePath: '',
      isConfiramationDialog: false,
      isIframeMounted: true,
    };
  },
  mounted() {
    document.getElementById('code-server')[0].contentDocument.location.reload(true);
  },
  methods: {
    checkApplicantStatus(status) {
      this.applicantStatus = status;
    },
    callConfiramationDialog() {
      this.isConfiramationDialog = true;
    },
    callUpdateApplicantStatusAndRedirect() {
      Promise.resolve()
        .then(() =>
          // 試験終了時間を取得する
          this.$axios.get('/api/exam/time'))
        .then((response) => {
          const endTime = new Date(response.data.endTime);
          const now = new Date();
          // if文はバックエンドの予約実行で既にcode-serverが落ちている状況で試験終了ボタンが押されたときの対策
          if (now < endTime) {
            this.$axios.post('/api/exam/end_time'); // container_durationの試験終了時間を上書きする
            this.$axios.post('/api/exam/close');
          }
          window.location.href = '/exam/redirect_by_status';
        })
        .catch((e) => {
        // TODO: エラーが出たときの処理
          console.log(e);
        });
    },
    onCancel() {
      this.isConfiramationDialog = false;
    },
  },
  created() {
    this.$axios.get('/api/container/port')
      .then((res) => {
        const containerPort = res.data;
        // TODO：GCPに上げたときにこの書き方で動作するかを確認する
        this.iframePath = `${location.protocol}//${location.hostname}:${containerPort}`;
      })
      .catch(
        // TODO：コンテナのポートが取得できなかったときの処理
      );
  },
};
</script>

<style scoped>
.btn.disabled, .btn:disabled {
    opacity: 1.0;
}
.coding-test {
  height: calc(100vh-52px); /* headerの長さだけ値を引く */
  position: absolute;
  text-align: right;
  top: 52px;
  width: 100%;
  z-index: 100;
}
.end-button {
  font-size: 10px;
  font-weight: bold;
}
@media screen and (min-width: 950px) {
  .end-button {
    font-size: 13px;
    font-weight: bold;
  }
}
.timer {
  margin-right: 10px;
}
.two-button {
  position: fixed;
  right: 7px;
  top: calc(52px/2);
  transform: translate(0%, -50%);
}
.h-iframe iframe {
  height: calc(100vh-52px);
  width: 100%;
}
.h-iframe {
  height: calc(100vh-52px);
  width: 100%;
}
</style>
